import React from 'react'
import { menuList } from '@/module/home/constant'
import { Link } from 'react-router-dom'
import { useSelected } from '@/module/home/hook'
import { useAuth } from '@/module/auth/hook'
import { Paths } from '@/api/paths'

function SideMenu() {
  const { user } = useAuth()
  const { productType } = useSelected()

  return (
    <header className='navbar hidden lg:flex lg:flex-col lg:w-[300px] h-screen bg-slate-200'>
      <div className='flex-none w-full justify-left'>
        <div className='p-3 text-xl font-bold select-none'>
          Sconn<p>User Manager</p>
        </div>
      </div>
      <div className='items-start flex-1 w-full mt-2'>
        <ul className='w-full p-2 menu menu-compact rounded-box'>
          <li className='menu-title'>
            <span>상품 목록</span>
          </li>
          {menuList.map((menu) => (
            <li key={menu.id}>
              <Link to={`/${menu.id}`} className={`${menu.id === productType ? 'active' : ''}`}>
                {menu.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className='flex items-center w-full'>
        <div className='dropdown dropdown-top'>
          <label tabIndex={0} className='btn btn-ghost btn-circle avatar'>
            <div className='w-8 rounded-full'>
              <img src={user.picture} alt={`${user.name}'s profile`} />
            </div>
          </label>
          <ul
            tabIndex={0}
            className='p-2 mt-3 shadow menu menu-compact dropdown-content bg-slate-200 rounded-box w-52'
          >
            <li>
              <a href={(process.env.REACT_APP_API_SERVER_URL as string) + Paths.SIGNOUT}>Logout</a>
            </li>
          </ul>
        </div>
        <div className='text-sm'>{user.name}</div>
      </div>
    </header>
  )
}

export default SideMenu
